/**
 * Shared label maps — the service and meter vocabulary the suite seeds
 * (`billing-plan-catalog.sql`) rendered in human words. Unknown ids/keys fall
 * back to their raw value so a future service never renders blank.
 */
import type { BillingLabels } from "../strings";

export function serviceLabel(labels: BillingLabels, serviceId: string): string {
  if (serviceId === "storage") return labels.serviceStorage;
  if (serviceId === "bandwidth") return labels.serviceBandwidth;
  if (serviceId === "ai") return labels.serviceAi;
  if (serviceId === "tts") return labels.serviceTts;
  return serviceId;
}

export function meterLabel(labels: BillingLabels, key: string): string {
  if (key === "monthly_storage_bytes") return labels.serviceStorage;
  if (key === "max_file_bytes") return labels.meterFileCap;
  if (key === "monthly_bandwidth_bytes") return labels.serviceBandwidth;
  if (key === "monthly_ai_tokens" || key === "ai_token_pack") return labels.serviceAi;
  if (key === "monthly_minutes") return labels.meterTtsMinutes;
  return key;
}
